import {
  Card,
  CardContent,
  InputLabel,
  Stack,
  Typography
} from '@mui/material';
import Grid from '@mui/material/Grid';

import useStyles from './ViewDataProviders.styles';
import type { AwsS3DataProvidersProps } from './ViewDataProviders.types';

const AwsS3DataProviders = ({ providers }: AwsS3DataProvidersProps) => {
  const { classes } = useStyles();

  if (!providers.length) {
    return (
      <Typography color="text.secondary">
        No AWS S3 data providers configured
      </Typography>
    );
  }

  return (
    <Stack spacing={1}>
      <Card
        className={classes.cardGridLayoutWrapper}
        variant="outlined"
        sx={{ px: 2, py: 2 }}
      >
        {providers.map((provider) => (
          <Grid key={provider.name} container spacing={1}>
            <Grid sx={{ display: 'flex' }} size={{ xs: 12 }}>
              <InputLabel sx={{ flexGrow: 1 }}>Name</InputLabel>
              <Typography>{provider.name}</Typography>
            </Grid>

            <Grid sx={{ display: 'flex' }} size={{ xs: 12 }}>
              <InputLabel sx={{ flexGrow: 1 }}>Prefix</InputLabel>
              <Typography>{provider.prefix}</Typography>
            </Grid>

            {Array.isArray(provider?.log_type) &&
              provider.log_type.length > 0 && (
                <Grid size={{ xs: 12 }}>
                  <Card
                    variant="outlined"
                    sx={{ maxHeight: 128, overflow: 'auto' }}
                  >
                    <Typography sx={{ px: 2, pt: 1 }}>Log Types</Typography>
                    <CardContent sx={{ pt: 1 }}>
                      <Typography variant="body2">
                        {provider?.log_type?.join(', ')}
                      </Typography>
                    </CardContent>
                  </Card>
                </Grid>
              )}
          </Grid>
        ))}
      </Card>
    </Stack>
  );
};

export default AwsS3DataProviders;
